<div class="content">
    <p>
        <b>{{ 'Doc2Txt' | i18n }}</b>
        {{ 'develops solutions for businesses for document scanning using OCR and machine learning technologies.' | i18n }}
    </p>
    <h4>{{ 'Services' | i18n }}</h4>
    <p>
        {{ 'Extract important information from PDFs and images.' | i18n }},
        {{ 'Send to Excel, Google Docs, and more.' | i18n }}
    </p>
    <p>
        <a class="btn btn-success" routerLink="/receiptPage" routerLinkActive="active" role="button">{{ 'Click here to try without cost' | i18n }}</a>
    </p>
    <h4>{{ 'How it works' | i18n }}</h4>
    <p>
        <b>{{ 'Doc2Txt' | i18n }}</b>
        {{ 'identifies and extracts data from PDFs and images using OCR technology,' | i18n }}
        {{ 'advanced pattern recognition, and keywords.' | i18n }}
    </p>
    <h4>{{ 'Types of Documents' | i18n }}</h4>
    <ul>
        <li>{{ 'Invoices' | i18n }}</li>
        <li>{{ 'Purchase Orders' | i18n }}</li>
        <li>{{ 'Pay Slips' | i18n }}</li>
        <li>{{ 'Bank Statements' | i18n }}</li>
        <li>{{ 'Passports and Official Documents' | i18n }}</li>
        <li>{{ 'Forms and Tables' | i18n }}</li>
    </ul>
    <h1>{{ 'Contact Us' | i18n }}</h1>
    <p>{{ 'You can reach us at:' | i18n }}</p>
    <ul>
        <li>{{ 'Email:' | i18n }} <a href="mailto:zapit.info@gmail.com">zapit.info@gmail.com</a></li>
        <li>{{ 'Phone/WhatsApp:' | i18n }} <a href="tel:0585307276">058-5307276</a></li>
    </ul>
</div>
